/* eslint-disable @next/next/no-img-element */
import {Image, Modal} from "react-bootstrap";
import {useForm} from "react-hook-form";
import {useEffect, useState} from "react";
import {isEmpty, isObject} from "lodash";
import Select from "react-select";
import http from "../../../utilities/http";
import {getCookie} from "../../../framework/libs/cookie";
import {TOKEN_CONGDONG, TOKEN_SHOP} from "../../../framework/store/constants";
import {API_URL_V2} from "../../../utilities/constants";
import {toast} from "react-toastify";
import {useRouter} from 'next/router';
import {useCart} from "framework/store";
import {Loader} from "components/loader";
import {isArray} from "lodash";
import {Checkbox, Flex} from "antd";
import axios from "axios";

const GENDER_LIST = ['Nam', 'Nữ', 'Khác'];

export default function Index({user, xaPhuong, setIsProfessional}) {
    const [loading, setLoading] = useState(false);

    //get jobservice
    useEffect(() => {
        const fetchJob = async () => {
            const res = await http('user-profile-data', {},
                {token: 'Bearer ' + getCookie(TOKEN_CONGDONG)}, 'v2');
            if (res.code === 200) {
                setState({
                    job_titles0p: res.data.job_titles?.data?.map(x => ({value: x.id, label: x.name})),
                    servicesOp: res.data.services?.data?.map(x => ({value: x.id, label: x.name})),
                    stylesOp: res.data.styles?.data?.map(x => ({value: x.id, label: x.name}))
                });
            }
        };
        fetchJob();
    }, []);
    const tinhOp = xaPhuong.map(x => ({value: x.id, label: x.name}));
    const [state, _setState] = useState({
        //currentForm
        currentForm: "",
        //avatar
        avatar: user.avatar,
        avatarValue: "",
        displayButtonAva: false,
        //job title
        job_titles0p: [],
        servicesOp: [],
        styles0p: [],
        job_titles: [],
        services: [],
        styles: [],
        //form
        companyAction: !!user?.is_company,
        fullName: user?.display_name || "",
        birthday: user?.birthday || "",
        gender_id: user?.gender_id || (GENDER_LIST.findIndex(x => x == user.gender) + 1) || "",
        phone: user?.phone_number || user?.phone || "",
        address: user?.address || "",
        //
        quanOp: [],
        xaOp: [],
        tinh: "",
        quan: "",
        xa: "",
        addressTemp: [],
        cmnd_number: "",
        cmnd_date: user?.cmnd_date || '',
        bio: user?.bio,
        //cmt
        cmnd_image_front: user?.cmnd_image_front?.url || '',
        cmnd_image_back: user?.cmnd_image_back?.url || '',
        company_name: "",
        // social
        website: user.links?.website || '',
        facebook: user.links?.facebook || '',
        instagram: user.links?.instagram || '',
        youtube: user.links?.youtube || '',
        flickr: user.links?.flickr || '',
        current: "",
        contentTempt: "",
        modalLink: false,
        validate_fullname: "",
        validate: false,
        validateStatus: false,

        tax_number: '',
        validatePhoneNo: false,
        registration_images1: "",
        registration_images2: ""
    });
    const setState = (_state = {}) => {
        _setState((state) => ({
            ...state,
            ..._state
        }));
    };
    const [isVerify, setIsVerify] = useState(false);
    useEffect(() => {
        const fetch = async () => {
            if (!user.is_professional && !user.is_professional_unverified) return;
            const res = await http(`community/professional/${user.id}`, {}, {}, 'v2');

            if (res.code === 200) {
                const data = res.data;
                setState({
                    styles: (data.styles?.data || []).map(x => ({value: x.id, label: x.name})),
                    services: (data.fields?.data || []).map(x => ({value: x.id, label: x.name})),
                    job_titles: (data.job_titles?.data || []).map(x => ({value: x.id, label: x.name})),
                    company_name: data.company_name,
                    tinh: {value: data.province.id, label: data.province.name},
                    quan: {value: data.district.id, label: data.district.name},
                    xa: {value: data.ward.id, label: data.ward.name},
                    address: data.address,
                    bio: data.bio,
                    website: data.links.website || '',
                    facebook: data.links.facebook || '',
                    instagram: data.links.instagram || '',
                    youtube: data.links.youtube || '',
                    flickr: data.links.flickr || '',
                    cmnd_number: data.cmnd_number || '',
                    phone: data.phone,
                    cmnd_image_front: data.cmnd_image_front?.url || '',
                    cmnd_image_back: data.cmnd_image_back?.url || '',
                    cmnd_date: data.cmnd_date || '',
                    certificates1: !isEmpty(data.certificates) ? data.certificates[0]?.url : '',
                    certificates2: !isEmpty(data.certificates) ? data.certificates[1]?.url : '',
                    registration_images1: !isEmpty(data.registration_images) ? data.registration_images[0]?.url : '',
                    registration_images2: !isEmpty(data.registration_images) ? data.registration_images[1]?.url : '',
                });
            }
        };

        fetch();
    }, []);

    //infor form
    const {register, handleSubmit, setValue} = useForm();
    const onSubmit = async (data) => {
        if (state.currentForm === "avatar") {
            const formData = new FormData();
            formData.append('avatar', data.avatar[0]);
            const res = await fetch(API_URL_V2 + 'user/update-profile-picture', {
                body: formData,
                method: 'POST',
                headers: new Headers({
                    'Authorization': 'Bearer ' + getCookie(TOKEN_CONGDONG)
                })
            });
            if (res.ok) {
                setState({displayButtonAva: false});
                toast.info('Đổi ảnh đại diện thành công');
            } else {
                toast.error('Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        } else if (state.currentForm === "infor") {
            const formData = new FormData();
            formData.append('job_title_ids', state.services.map(x => x.value));
            formData.append('field_ids', state.job_titles.map(x => x.value));
            formData.append('style_ids', state.styles.map(x => x.value));
            formData.append('province_id', state.tinh.value);
            formData.append('district_id', state.quan.value);
            formData.append('ward_id', state.xa.value);
            formData.append('address', state.address);
            formData.append('phone_number', state.phone);

            if (state.companyAction === true) {
                if (!isEmpty(state.company_name) && !isEmpty(state.tax_number) && state.validatePhoneNo == true && !isEmpty(state.address) &&
                    !isEmpty(state.tinh) && !isEmpty(state.quan) && !isEmpty(state.xa) && !isEmpty(state.registration_images1) &&
                    !isEmpty(state.registration_images2) && !isEmpty(state.job_titles) && !isEmpty(state.services) && !isEmpty(state.bio)) {
                    formData.append('is_company', true);
                    formData.append('company_name', state.company_name);
                    formData.append('tax_number', state.tax_number);
                    formData.append('registration_images[]', data.registration_images1[0]);
                    formData.append('registration_images[]', data.registration_images2[0]);
                    // formData.append("certificates[]", data.certificates1[0]);
                    // formData.append("certificates[]", data.certificates2[0]);
                    formData.append('bio', state.bio);
                    try {
                        setLoading(true);
                        const res = await fetch(API_URL_V2 + `community/professional/register-company`, {
                            body: formData,
                            method: 'POST',
                            headers: new Headers({
                                'Authorization': 'Bearer ' + getCookie(TOKEN_CONGDONG)
                            })
                        });
                        await sendVerify();
                        if (res.status == 200) {
                            setState({validate: false});
                            toast.info('Bạn đã đăng ký thành công. Happynest sẽ duyệt hồ sơ và thông báo kết quả tới bạn sớm nhất.');
                            setTimeout(function () {
                                // router.reload();;
                            }, 2000);
                        } else {
                            toast.error(res?.json()?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
                        }
                        setLoading(false);
                    } catch (e) {
                        console.log(e);
                    }
                }
            } else if (state.companyAction === false) {
                if (!isEmpty(state.fullName) && [1, 2, 3].includes(state.gender_id) && state.validatePhoneNo == true && !isEmpty(state.address) &&
                    !isEmpty(state.tinh) && !isEmpty(state.quan) && !isEmpty(state.xa) && !isEmpty(state.cmnd_image_back) &&
                    !isEmpty(state.cmnd_image_front) && !isEmpty(state.job_titles) && !isEmpty(state.services) && !isEmpty(state.bio)
                ) {
                    formData.append('is_company', false);
                    formData.append('fullname', state.fullName);
                    formData.append('gender_id', state.gender_id);
                    formData.append('birthday', state.birthday);
                    formData.append('cmnd_number', state.cmnd_number);
                    formData.append('cmnd_date', state.cmnd_date);
                    formData.append('cmnd_image_front', data.cmnd_image_front[0]);
                    formData.append('cmnd_image_back', data.cmnd_image_back[0]);
                    const certificates = [data.certificates1[0], data.certificates2[0]];
                    certificates.forEach((certificate) => {
                        formData.append("certificates[]", certificate);
                    });
                    formData.append('bio', state.bio);
                    formData.append('website', state.website);
                    formData.append('facebook', state.facebook);
                    formData.append('instagram', state.instagram);
                    formData.append('youtube', state.youtube);
                    formData.append('flickr', state.flickr);
                    try {
                        setLoading(true);
                        const res = await fetch(API_URL_V2 + `community/professional/register`, {
                            body: formData,
                            method: 'POST',
                            headers: new Headers({
                                'Authorization': 'Bearer ' + getCookie(TOKEN_CONGDONG)
                            })
                        });
                        await sendVerify();
                        if (res.status == 200) {
                            setState({validate: false});
                            toast.info('Bạn đã đăng ký thành công. Happynest sẽ duyệt hồ sơ và thông báo kết quả tới bạn sớm nhất.');
                            setTimeout(function () {
                                // router.reload();;
                            }, 2000);
                        } else {
                            toast.error(res?.json()?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
                        }
                        setLoading(false);
                    } catch (e) {
                        console.log(e);
                    }
                }
            }
        }
    };

    const sendVerify = async () => {
        if (!isVerify) return;
        const payload = {
            method: "POST",
            headers: new Headers({
                'Authorization': 'Bearer ' + getCookie(TOKEN_CONGDONG),
                'Content-Type': 'application/json'
            }),
            body: JSON.stringify({
                is_verify: 1,
            }),
        };
        const res = await fetch(API_URL_V2 + `community/professional/verify`, payload);
        if (res.status !== 200) {
            const data = await res.json();
            toast.error(data?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
        }
        return res;
    };

    //select địa chỉ
    useEffect(() => {
        if (!isEmpty(state.tinh)) {
            const listQuan = xaPhuong.find(x => x.id === (state.tinh).value);
            setState({
                quanOp: listQuan?.districts?.data?.map(x => ({value: x.id, label: x.name})),
            });
            if (!isEmpty(state.quan) && !listQuan.districts.data.some(x => x.id === state.quan.value)) {
                setState({quan: ""});
            }
        }
    }, [state.tinh]);

    useEffect(() => {
        if (!isEmpty(state.quan)) {
            const listQuan = xaPhuong.find(x => x.id === (state.tinh).value);
            const listXa = listQuan.districts.data.find(x => x.id === (state.quan).value).wards.data;
            setState({
                xaOp: listXa?.map(x => ({value: x.id, label: x.name})),
            });

            if (!isEmpty(state.xa) && !listXa.some(x => x.id === state.xa.value)) {
                setState({xa: ""});
            }

        } else {
            setState({
                xa: "",
                xaOp: []
            });
        }
    }, [state.quan]);

    const customStyles = {
        control: (base) => ({
            ...base,
            color: 'black',
            cursor: 'pointer',
            paddingLeft: '5px',
        }),
        valueContainer: (base) => ({
            ...base,
            // maxHeight: '64px',
            // 'overflow-y': 'scroll'
        }),
        option: (base) => ({
            ...base,
            cursor: 'pointer',
        }),
        placeholder: (defaultStyles) => ({
            ...defaultStyles,
            color: 'black',
        }),
        indicatorSeparator: (base) => ({
            ...base,
            display: 'none'
        })
    };
    const changeCmtFront = (e) => {
        if (e.target.files.length !== 0) {
            setState({cmnd_image_front: URL.createObjectURL(e.target.files[0]),});
            // setValue("cmnd_image_front", e.target.files);
        }
    };
    const changeCmtBack = (e) => {
        if (e.target.files.length !== 0) {
            setState({cmnd_image_back: URL.createObjectURL(e.target.files[0]),});
            // setValue("cmnd_image_back", e.target.files);
        }
    };
    const changeCertificates1 = (e) => {
        if (e.target.files.length !== 0) {
            setState({certificates1: URL.createObjectURL(e.target.files[0]),});
            // setValue("certificates1", e.target.files);
        }
    };
    const changeCertificates2 = (e) => {
        if (e.target.files.length !== 0) {
            setState({certificates2: URL.createObjectURL(e.target.files[0]),});
            // setValue("certificates2", e.target.files);
        }
    };
    const changRegistrationImages1 = (e) => {
        if (e.target.files.length !== 0) {
            setState({registration_images1: URL.createObjectURL(e.target.files[0]),});
            // setValue("registration_images1", e.target.files);
        }
    };
    const changRegistrationImages2 = (e) => {
        if (e.target.files.length !== 0) {
            setState({registration_images2: URL.createObjectURL(e.target.files[0]),});
            // setValue("registration_images2", e.target.files);
        }
    };
    const changeAvatar = (e) => {
        if (e.target.files.length !== 0) {
            setState({
                avatarValue: e.target.files,
                avatar: URL.createObjectURL(e.target.files[0]),
                displayButtonAva: true
            });
        }
    };
    const deleteAvatar = () => {
        setState({
            avatarValue: "",
            avatar: user?.avatar,
            displayButtonAva: false
        });
    };
    //modal
    const showLinkModal = (currentLink) => {
        setState({
            modalLink: true,
            current: currentLink,
            contentTempt: state[currentLink]
        });
    };
    const onHideModal = () => {
        setState({
            modalLink: false,
            contentTempt: "",
            current: "",
        });
    };
    const saveLink = () => {
        setState({
            modalLink: false,
            [state.current]: state.contentTempt,
            contentTempt: "",

        });
    };
    const linkLabeLModal = {
        website: "Website",
        facebook: "Facebook",
        instagram: "Instagram",
        youtube: "Youtube",
        flickr: "TikTok"
    };
    const genLinkModal = () => {
        return (
            <Modal show={state.modalLink} onHide={onHideModal} role="document" className="modal-form-link">
                <Modal.Header closeButton>
                    <h5 className="modal-title">Thêm liên kết {linkLabeLModal[state.current]}</h5>
                </Modal.Header>
                <Modal.Body>
                    <div className="inputLink">
                        <div className="inputLink-form mt-0">
                            <input className="form-control" type="text"
                                placeholder={"Hãy nhập liên kết " + linkLabeLModal[state.current] + " của bạn..."}
                                onChange={(e) => {
                                    setState({contentTempt: e.target.value});
                                }}
                                value={state.contentTempt}
                            />
                            <ul className="btn-footer">
                                <li>
                                    <button className="btn btn--redWhite" onClick={() => {
                                        onHideModal();
                                    }}>Hủy bỏ
                                    </button>
                                </li>
                                <li>
                                    <button className="btn btn--blue" onClick={() => {
                                        saveLink();
                                    }}>Lưu
                                    </button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        );
    };
    return <div>
        <Loader loading={loading}/>
        <div className="wrap">
            <div className="wrapContent">
                <div className="user-thumb">
                    <Image className="thumb" src={state.avatar || "/images/user-thumb-expert.png"} alt=""/>
                    <button className="btn-change">
                        <form onSubmit={handleSubmit(onSubmit)} id="avatar-form">
                            <input {...register('avatar')} className="custom-file-input"
                                accept="image/png, image/jpeg" type="file" onChange={changeAvatar}
                                style={{position: "absolute", display: "block"}}
                            />
                            <img src="/images/icon-edit.svg"/>
                        </form>
                    </button>
                </div>
                {
                    state.displayButtonAva &&
                    <div className="text-center" style={{margin: "10px auto"}}>
                        <button className="btn" onClick={() => deleteAvatar()}>Hủy</button>
                        <button type="submit" className="btn btn--blue" form="avatar-form"
                            onClick={() => {
                                setState({currentForm: "avatar"});
                            }}>Lưu ảnh đại diện
                        </button>
                    </div>
                }
                <form onSubmit={handleSubmit(onSubmit)} id="infor-form">
                    <div className="user-form bb-sp">
                        <ul className="select-action">
                            <li className={state.companyAction ? "" : "active"}
                                onClick={() => {
                                    setState({companyAction: false});
                                }}>
                                <span className="icon">
                                    <Image className="svg" src="/images/icon-profileLogin.svg"/></span>
                                Hoạt động cá nhân
                            </li>
                            <li className={state.companyAction ? "active" : ""}
                                onClick={() => {
                                    setState({companyAction: true});
                                }}>
                                <span className="icon"><Image className="svg" src="/images/icon-work.svg"/></span>
                                Hoạt động theo công ty
                            </li>
                        </ul>
                    </div>
                    {!state.companyAction && <>
                        <div className="row row-20">
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="form-title">Họ và tên <span className="c-red">*</span></label>
                                    <input type="" className="form-control" name="" placeholder="Nhập tên của bạn"
                                        value={state.fullName}
                                        onChange={(e) => {
                                            setState({fullName: e.target.value});
                                        }}/>
                                    {state.validate && isEmpty(state.fullName) &&
                                        <p style={{color: "red"}}>Vui lòng nhập tên đầy đủ</p>}
                                </div>
                                <div className="form-group">
                                    <label className="form-title">Ngày sinh</label>
                                    <input type="date" style={{padding: "10px"}} className="form-control" name=""
                                        placeholder="Nhập ngày sinh của bạn"
                                        value={state.birthday}
                                        onChange={(e) => {
                                            setState({birthday: e.target.value});
                                        }}/>
                                    {/*{state.validate && isEmpty(state.birthday) && <p style={{color: "red"}}>Vui lòng nhập ngày sinh của bạn</p>}*/}
                                </div>
                                <div className="form-group">
                                    <label className="form-title">Giới tính</label>
                                    <div>
                                        {
                                            GENDER_LIST.map((item, index) => {
                                                const id = index + 1;
                                                return <label key={index} className="custom-control custom-radio mr-5">
                                                    <input id={"sex" + (index + 1)} name="sex"
                                                        className="custom-control-input" type="radio"
                                                        onChange={() => setState({gender_id: id})}
                                                        checked={state.gender_id == id}/>
                                                    <span className="custom-control-indicator"></span>
                                                    <span className="custom-control-description">{item}</span>
                                                </label>;
                                            })
                                        }
                                    </div>
                                    {state.validate && !state.gender_id &&
                                        <p style={{color: "red"}}>Vui lòng nhập giới tính</p>}
                                </div>
                                <div className="form-group">
                                    <label className="form-title">Điện thoại <span className="c-red">*</span></label>
                                    <input type="" className="form-control" name="" value={state.phone} maxLength="15"
                                        placeholder="Nhập số điện thoại của bạn"
                                        onChange={(e) => {
                                            setState({phone: e.target.value});
                                        }}/>
                                    {
                                        (() => {
                                            if (state.validate) {
                                                if (isEmpty(state.phone)) {
                                                    return <p style={{color: "red"}}>Vui lòng nhập số điện thoại</p>;
                                                } else {
                                                    if (state.phone.length <= 9) {
                                                        return <p style={{color: "red"}}>Số điện thoại cần tối thiểu 10
                                                            ký tự</p>;
                                                    } else {
                                                        let status = 0;
                                                        state.phone.split("").forEach(x => {
                                                            !Number.isInteger(+x) ? status++ : "";
                                                        });
                                                        return status > 0 ?
                                                            <p style={{color: "red"}}>Số điện thoại cần tối thiểu 10 ký
                                                                tự số</p> :
                                                            (state.validatePhoneNo == false ? setState({validatePhoneNo: true}) : "");

                                                    }
                                                }

                                            }
                                        })()
                                    }
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="form-title">Email <span className="c-red">*</span></label>
                                    <input type="" className="form-control" name="" disabled value={user.email}/>
                                </div>
                                <div className="form-group">
                                    <label className="form-title">Địa chỉ <span className="c-red">*</span> </label>
                                    <div className="mb-2">
                                        <Select
                                            options={tinhOp}
                                            styles={customStyles}
                                            placeholder={state.tinh.label || "Tỉnh/Thành phố"}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={selecteds => {
                                                setState({tinh: selecteds});
                                            }}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <Select
                                            options={state.quanOp}
                                            styles={customStyles}
                                            placeholder={"Quận/huyện"}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={selecteds => {
                                                setState({quan: selecteds});
                                            }}
                                            value={state.quan}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <Select
                                            options={state.xaOp}
                                            styles={customStyles}
                                            placeholder={"Phố/Xã/Phường"}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={selecteds => {
                                                setState({xa: selecteds});
                                            }}
                                            value={state.xa}
                                        />
                                    </div>
                                    <div>
                                        <input className="form-control" type="text" value={state.address}
                                            placeholder="Nhập địa chỉ của bạn"
                                            onChange={(e) => {
                                                setState({address: e.target.value});
                                            }}/>
                                        {state.validate && (isEmpty(state.address) || isEmpty(state.tinh) || isEmpty(state.quan) || isEmpty(state.xa)) &&
                                            <p style={{color: "red"}}>Vui lòng nhập địa chỉ</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="user-form bb-sp">
                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">CMND/ CCCD
                                        <span className="c-red">*</span>
                                    </label>
                                    <input type="" className="form-control" value={state.cmnd_number}
                                        placeholder="Nhập số CMND/ CCCD của bạn"
                                        onChange={(e) => {
                                            setState({cmnd_number: e.target.value});
                                        }}/>
                                    {state.validate && isEmpty(state.cmnd_number) &&
                                        <p style={{color: "red"}}>Vui lòng nhập CMND/ CCCD</p>}
                                </div>
                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">Ngày cấp
                                        {/*<span className="c-red">*</span>*/}
                                    </label>
                                    <div className="form-icon icon-right">
                                        <input className="form-control" type="date" style={{padding: "10px"}} name=""
                                            value={state.cmnd_date}
                                            placeholder="Nhập ngày cấp CMND/ CCCD của bạn"
                                            onChange={(e) => {
                                                setState({cmnd_date: e.target.value});
                                            }}/>
                                        {/*{state.validate && isEmpty(state.cmnd_date) && <p style={{color: "red"}}>Vui lòng nhập ngày cấp CMND/ CCCD</p>}*/}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">Ảnh CMND/CCCD (2 mặt)
                                        <span className="c-red">*</span>
                                    </label>
                                    <ul className="formUpload-thumb">
                                        <li style={{position: "relative"}} className="wrap-next-image">
                                            <input className="custom-file-input cursor-pointer" type="file"
                                                {...register('cmnd_image_front')}
                                                accept="image/png, image/jpeg" onChange={changeCmtFront}
                                                style={{position: "absolute", display: "block", height: "100%"}}/>
                                            <img src={state.cmnd_image_front || "/images/icon-update.svg"} alt=""/>
                                        </li>
                                        <li style={{position: "relative"}} className="wrap-next-image">
                                            <input className="custom-file-input cursor-pointer" type="file"
                                                {...register('cmnd_image_back')}
                                                accept="image/png, image/jpeg" onChange={changeCmtBack}
                                                style={{position: "absolute", display: "block", height: "100%"}}/>
                                            <img src={state.cmnd_image_back || "/images/icon-update.svg"} alt=""/>
                                        </li>
                                    </ul>
                                    {state.validate && (isEmpty(state.cmnd_image_back) || isEmpty(state.cmnd_image_front)) &&
                                        <p style={{color: "red"}}>Vui lòng tải lên ảnh CMND/ CCCD</p>}
                                </div>
                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">Bằng cấp</label>
                                    <ul className="formUpload-thumb">
                                        <li style={{position: "relative"}} className="wrap-next-image">
                                            <input className="custom-file-input" type="file"
                                                {...register('certificates1')}
                                                multiple
                                                accept="image/png, image/jpeg" onChange={changeCertificates1}
                                                style={{position: "absolute", display: "block", height: "100%"}}/>
                                            <img src={state.certificates1 || "/images/icon-update.svg"} alt=""/>
                                        </li>
                                        <li style={{position: "relative"}} className="wrap-next-image">
                                            <input className="custom-file-input" type="file"
                                                {...register('certificates2')}
                                                accept="image/png, image/jpeg" onChange={changeCertificates2}
                                                style={{position: "absolute", display: "block", height: "100%"}}/>
                                            <img src={state.certificates2 || "/images/icon-update.svg"} alt=""/>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                        <div className="user-form bb-sp">
                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">Lĩnh vực (Hãy chọn tối đa 5 mục)<span
                                        className="c-red">*</span></label>
                                    <Select
                                        isMulti={true}
                                        options={state.servicesOp}
                                        styles={customStyles}
                                        placeholder={"Lĩnh vực của bạn"}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        onChange={selecteds => {
                                            if (selecteds.length > 5) return;
                                            setState({services: selecteds});
                                        }}
                                        value={state.services}
                                    />
                                    {state.validate && isEmpty(state.services) &&
                                        <p style={{color: "red"}}>Vui lòng chọn lĩnh vực</p>} </div>

                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">Vai trò (Hãy chọn tối đa 3 mục)<span
                                        className="c-red">*</span></label>
                                    <Select
                                        isMulti={true}
                                        options={state.job_titles0p}
                                        styles={customStyles}
                                        placeholder={"Vai trò của bạn"}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        onChange={selecteds => {
                                            if (selecteds.length > 3) return;
                                            setState({job_titles: selecteds});
                                        }}
                                        value={state.job_titles}
                                    />
                                    {state.validate && isEmpty(state.job_titles) &&
                                        <p style={{color: "red"}}>Vui lòng chọn vai trò</p>}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">Phong cách (hãy chọn tối đa 5 mục)
                                        {/*<span className="c-red">*</span>*/}
                                    </label>
                                    <Select
                                        isMulti={true}
                                        options={state.stylesOp}
                                        styles={customStyles}
                                        placeholder={"Phong cách của bạn"}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        onChange={selecteds => {
                                            if (selecteds.length > 5) return;
                                            setState({styles: selecteds});
                                        }}
                                        value={state.styles}
                                    />
                                </div>
                                {/*{state.companyAction &&*/}
                                {/*    <div className="col-12 col-md-6 mb-3">*/}
                                {/*        <label className="form-title">Công ty của bạn<span className="c-red">*</span></label>*/}
                                {/*        <div className="form-icon icon-right">*/}
                                {/*            <input className="form-control" type="input" style={{ padding: "10px" }} name="" value={state.company_name}*/}
                                {/*                placeholder="Nhập tên công ty của bạn của bạn"*/}
                                {/*                onChange={(e) => { setState({ company_name: e.target.value }); }} />*/}
                                {/*        </div>*/}
                                {/*        {state.validate && isEmpty(state.company_name) && <p style={{ color: "red" }}>Vui lòng nhập tên công ty của bạn</p>}*/}
                                {/*    </div>*/}
                                {/*}*/}
                            </div>
                        </div>
                        <div className="user-description">
                            <h3 className="title-desc">Mô tả <span className="c-red">*</span></h3>
                            <textarea className="form-control desc-box" value={state.bio} style={{height: "180px"}}
                                placeholder="Nhập miêu tả của bạn"
                                onChange={(e) => {
                                    setState({bio: e.target.value});
                                }}>
                            </textarea>
                            {state.validate && isEmpty(state.bio) &&
                                <p style={{color: "red"}}>Vui lòng nhập miêu tả ngắn về bạn</p>}
                        </div>
                        <div className="social-link">
                            <span className="social-tit">Liên kết</span>
                            <ul className="list-social" style={{cursor: 'pointer'}}>
                                <li><a><img src="/images/social-Website.svg" alt=""
                                    onClick={() => {
                                        showLinkModal("website");
                                    }}/></a></li>
                                <li><a><img src="/images/social-Facebook.svg" alt=""
                                    onClick={() => {
                                        showLinkModal("facebook");
                                    }}/></a></li>
                                <li><a><img src="/images/social-Instagram.svg" alt=""
                                    onClick={() => {
                                        showLinkModal("instagram");
                                    }}/></a></li>
                                <li><a><img src="/images/social-Youtube.svg" alt=""
                                    onClick={() => {
                                        showLinkModal("youtube");
                                    }}/></a></li>
                                <li><a><img src="/images/social-Tiktok.svg" alt=""
                                    onClick={() => {
                                        showLinkModal("flickr");
                                    }}/></a></li>
                            </ul>
                        </div>
                    </>
                    }

                    {state.companyAction && <>
                        <div className="row row-20">
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="form-title">Tên công ty<span className="c-red">*</span></label>
                                    <input type="" className="form-control" name="" placeholder="Tên công ty"
                                        value={state.company_name}
                                        onChange={(e) => {
                                            setState({company_name: e.target.value});
                                        }}/>
                                    {state.validate && isEmpty(state.company_name) &&
                                        <p style={{color: "red"}}>Vui lòng nhập tên công ty</p>}
                                </div>
                                <div className="form-group">
                                    <label className="form-title">Mã số thuế<span className="c-red">*</span></label>
                                    <input type="" className="form-control" name="" placeholder="Mã số thuế"
                                        value={state.tax_number}
                                        onChange={(e) => {
                                            setState({tax_number: e.target.value});
                                        }}/>
                                    {state.validate && isEmpty(state.tax_number) &&
                                        <p style={{color: "red"}}>Vui lòng nhập mã số thuế</p>}
                                </div>
                                <div className="form-group">
                                    <label className="form-title">Số điện thoại <span className="c-red">*</span></label>
                                    <input type="" className="form-control" name="" value={state.phone} maxLength="15"
                                        placeholder="Nhập số điện thoại của bạn"
                                        onChange={(e) => {
                                            setState({phone: e.target.value});
                                        }}/>
                                    {
                                        (() => {
                                            if (state.validate) {
                                                if (isEmpty(state.phone)) {
                                                    return <p style={{color: "red"}}>Vui lòng nhập số điện thoại</p>;
                                                } else {
                                                    if (state.phone.length <= 9) {
                                                        return <p style={{color: "red"}}>Số điện thoại cần tối thiểu 10
                                                            ký tự</p>;
                                                    } else {
                                                        let status = 0;
                                                        state.phone.split("").forEach(x => {
                                                            !Number.isInteger(+x) ? status++ : "";
                                                        });
                                                        return status > 0 ?
                                                            <p style={{color: "red"}}>Số điện thoại cần tối thiểu 10 ký
                                                                tự số</p> :
                                                            (state.validatePhoneNo == false ? setState({validatePhoneNo: true}) : "");

                                                    }
                                                }

                                            }
                                        })()
                                    }
                                </div>
                            </div>
                            <div className="col-12 col-md-6">
                                <div className="form-group">
                                    <label className="form-title">Email <span className="c-red">*</span></label>
                                    <input type="" className="form-control" name="" disabled value={user.email}/>
                                </div>
                                <div className="form-group">
                                    <label className="form-title">Địa chỉ <span className="c-red">*</span> </label>
                                    <div className="mb-2">
                                        <Select
                                            options={tinhOp}
                                            styles={customStyles}
                                            placeholder={"Tỉnh/Thành phố"}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={selecteds => {
                                                setState({tinh: selecteds});
                                            }}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <Select
                                            options={state.quanOp}
                                            styles={customStyles}
                                            placeholder={"Quận/huyện"}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={selecteds => {
                                                setState({quan: selecteds});
                                            }}
                                            value={state.quan}
                                        />
                                    </div>
                                    <div className="mb-2">
                                        <Select
                                            options={state.xaOp}
                                            styles={customStyles}
                                            placeholder={"Phố/Xã/Phường"}
                                            closeMenuOnSelect={true}
                                            hideSelectedOptions={false}
                                            onChange={selecteds => {
                                                setState({xa: selecteds});
                                            }}
                                            value={state.xa}
                                        />
                                    </div>
                                    <div>
                                        <input className="form-control" type="text" value={state.address}
                                            placeholder="Nhập địa chỉ của bạn"
                                            onChange={(e) => {
                                                setState({address: e.target.value});
                                            }}/>
                                        {state.validate && (isEmpty(state.address) || isEmpty(state.tinh) || isEmpty(state.quan) || isEmpty(state.xa)) &&
                                            <p style={{color: "red"}}>Vui lòng nhập địa chỉ</p>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="user-form bb-sp">
                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">Giấy phép ĐK Kinh doanh
                                        <span className="c-red">*</span>
                                    </label>
                                    <ul className="formUpload-thumb">
                                        <li style={{position: "relative"}} className="wrap-next-image">
                                            <input className="custom-file-input" type="file"
                                                {...register('registration_images1')}
                                                accept="image/png, image/jpeg" onChange={changRegistrationImages1}
                                                style={{position: "absolute", display: "block", height: "100%"}}/>
                                            <img src={state.registration_images1 || "/images/icon-update.svg"} alt=""/>
                                        </li>
                                        <li style={{position: "relative"}} className="wrap-next-image">
                                            <input className="custom-file-input" type="file"
                                                {...register('registration_images2')}
                                                accept="image/png, image/jpeg" onChange={changRegistrationImages2}
                                                style={{position: "absolute", display: "block", height: "100%"}}/>
                                            <img src={state.registration_images2 || "/images/icon-update.svg"} alt=""/>
                                        </li>
                                    </ul>
                                    {state.validate && (isEmpty(state.registration_images1) || isEmpty(state.registration_images2)) &&
                                        <p style={{color: "red"}}>Vui lòng tải lên giấy phép ĐK Kinh doanh</p>}
                                </div>
                            </div>
                        </div>
                        <div className="user-form bb-sp">
                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">Lĩnh vực (Hãy chọn tối đa 5 mục)<span
                                        className="c-red">*</span></label>
                                    <Select
                                        isMulti={true}
                                        options={state.servicesOp}
                                        styles={customStyles}
                                        placeholder={"Lĩnh vực của bạn"}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        onChange={selecteds => {
                                            if (selecteds.length > 5) return;
                                            setState({services: selecteds});
                                        }}
                                        value={state.services}
                                    />
                                    {state.validate && isEmpty(state.services) &&
                                        <p style={{color: "red"}}>Vui lòng chọn lĩnh vực</p>} </div>

                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">Vai trò (Hãy chọn tối đa 3 mục)<span
                                        className="c-red">*</span></label>
                                    <Select
                                        isMulti={true}
                                        options={state.job_titles0p}
                                        styles={customStyles}
                                        placeholder={"Vai trò của bạn"}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        onChange={selecteds => {
                                            if (selecteds.length > 3) return;
                                            setState({job_titles: selecteds});
                                        }}
                                        value={state.job_titles}
                                    />
                                    {state.validate && isEmpty(state.job_titles) &&
                                        <p style={{color: "red"}}>Vui lòng chọn vai trò</p>}
                                </div>
                            </div>
                            <div className="row">
                                <div className="col-12 col-md-6 mb-3">
                                    <label className="form-title">Phong cách (hãy chọn tối đa 5 mục)
                                        {/*<span className="c-red">*</span>*/}
                                    </label>
                                    <Select
                                        isMulti={true}
                                        options={state.stylesOp}
                                        styles={customStyles}
                                        placeholder={"Phong cách của bạn"}
                                        closeMenuOnSelect={false}
                                        hideSelectedOptions={false}
                                        onChange={selecteds => {
                                            if (selecteds.length > 5) return;
                                            setState({styles: selecteds});
                                        }}
                                        value={state.styles}
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="user-description">
                            <h3 className="title-desc">Mô tả <span className="c-red">*</span></h3>
                            <textarea className="form-control desc-box" value={state.bio} style={{height: "180px"}}
                                placeholder="Nhập miêu tả của bạn"
                                onChange={(e) => {
                                    setState({bio: e.target.value});
                                }}>
                            </textarea>
                            {state.validate && isEmpty(state.bio) &&
                                <p style={{color: "red"}}>Vui lòng nhập miêu tả ngắn về bạn</p>}
                        </div>
                        <div className="social-link mb-4">
                            <span className="social-tit">Liên kết</span>
                            <ul className="list-social" style={{cursor: 'pointer'}}>
                                <li><a><img src="/images/social-Website.svg" alt=""
                                    onClick={() => {
                                        showLinkModal("website");
                                    }}/></a></li>
                                <li><a><img src="/images/social-Facebook.svg" alt=""
                                    onClick={() => {
                                        showLinkModal("facebook");
                                    }}/></a></li>
                                <li><a><img src="/images/social-Instagram.svg" alt=""
                                    onClick={() => {
                                        showLinkModal("instagram");
                                    }}/></a></li>
                                <li><a><img src="/images/social-Youtube.svg" alt=""
                                    onClick={() => {
                                        showLinkModal("youtube");
                                    }}/></a></li>
                                <li><a><img src="/images/social-Tiktok.svg" alt=""
                                    onClick={() => {
                                        showLinkModal("flickr");
                                    }}/></a></li>
                            </ul>
                        </div>
                    </>
                    }
                    <Flex align="flex-start" className="mb-4">
                        <Checkbox checked={isVerify} onChange={() => setIsVerify(!isVerify)}/>
                        <div className="ml-2">
                            <p className="">Đăng ký xác thực Hồ sơ năng lực bằng cách tick vào ô này</p>
                            <p className="color-AAA">Tìm hiểu thêm <a href="/dieu-khoan-chinh-sach">tại đây</a></p>
                        </div>
                    </Flex>
                    <div className="text-left">
                        {
                            !user.is_professional && !user.is_professional_unverified &&
                            <button type="submit" className="btn btn--blue btn-save"
                                onClick={() => {
                                    setState({
                                        currentForm: "infor",
                                        validate: true
                                    });
                                }}>Gửi đăng ký</button>
                        }
                        {
                            user.is_professional && <button type="submit" className="btn btn--blue btn-save"
                                onClick={() => {
                                    setState({
                                        currentForm: "infor",
                                        validate: true
                                    });
                                }}>Thay đổi thông tin</button>
                        }
                        {
                            user.is_professional_unverified &&
                            <button className="btn btn--blue btn-save" onClick={() => setIsProfessional(false)}>
                                Quay lại hồ sơ cá nhân
                            </button>
                        }
                    </div>
                </form>
            </div>
        </div>
        {genLinkModal()}
    </div>;
}
